import { GlobalTagBadge } from '../tags/GlobalTagBadge';
import { Plus } from 'lucide-react';

import { Badge } from '@/marketing/components/ui/badge';
import { Popover, PopoverContent, PopoverTrigger } from '@/marketing/components/ui/popover';
import type { CampaignInfluencer } from '@/marketing/models/campaignInfluencer';
import { CampaignInfluencerTagManager } from '../tags/CampaignInfluencerTagManager';
import { useCampaignInfluencerTagAssignment } from '../tags/useCampaignInfluencerTagAssignment';

interface CreatorCardTagsProps {
  campaignId: string;
  creator: CampaignInfluencer;
}

export function CreatorCardTags({ campaignId, creator }: CreatorCardTagsProps) {
  const { assignedTagIds, assignedTags, isAssignmentPending, toggleAssignment } = useCampaignInfluencerTagAssignment(
    campaignId,
    creator,
  );

  return (
    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-1">
      {assignedTags.map(({ tagId, name, isGlobal }) => (
        <Badge
          key={tagId}
          variant="secondary"
          title={name}
          className="tw-max-w-[220px] tw-gap-1 tw-px-1.5 tw-py-0 tw-text-[10px] tw-font-normal"
        >
          <span className="tw-min-w-0 tw-truncate">{name}</span>
          {isGlobal && <GlobalTagBadge />}
        </Badge>
      ))}
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="tw-inline-flex tw-items-center tw-gap-0.5 tw-rounded tw-border tw-border-dashed tw-border-border tw-px-1.5 tw-py-0.5 tw-text-[10px] tw-text-muted-foreground hover:tw-bg-accent hover:tw-text-foreground"
          >
            <Plus className="tw-h-3 tw-w-3" />
            Add tag
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="tw-w-auto tw-p-0">
          <CampaignInfluencerTagManager
            key={campaignId}
            campaignId={campaignId}
            assignedTagIds={assignedTagIds}
            isAssignmentPending={isAssignmentPending}
            onToggleAssignment={toggleAssignment}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
